import React from 'react'
import {CSSProperties} from 'react'

const FundingCardsGrid = () => {
  // Inline styles with explicit types
  const iconStyle: CSSProperties = {
    color: '#47be7d',
    fontSize: '3em', // Adjust icon size as needed
  }

  const cardStyle: CSSProperties = {
    alignItems: 'center',
    transition: 'box-shadow 0.3s ease-in-out',
    height: '150px', // Set a consistent height
    width: '100%', // Use the full width of the column
    display: 'flex',
    flexDirection: 'column', // Correct type for TypeScript
    justifyContent: 'center', // Center content vertically
  }

  const cardHoverStyle: CSSProperties = {
    boxShadow: '0px 0px 15px #47be7d',
  }

  const fundingData = [
    {
      amount: '$8.2 billion',
      description: 'estimated for Colorado',
      iconClass: 'fa-building-columns',
    },
    {amount: '$1.63 billion', description: 'for Roads, Bridges & Safety', iconClass: 'fa-bridge'},
    {
      amount: '$1.29 billion',
      description: 'for Resilience of infrastructure',
      iconClass: 'fa-house-flood-water',
    },
    {
      amount: '$1.58 billion',
      description: 'for Clean Energy & the Power Grid',
      iconClass: 'fa-solar-panel',
    },
    {amount: '$1 billion', description: 'for High-Speed Internet', iconClass: 'fa-wifi'},
    {amount: '$560 million', description: 'for Water systems', iconClass: 'fa-droplet'},
    {amount: '$23 million', description: 'for Public Transportation', iconClass: 'fa-bus'},
    {
      amount: '$86 million',
      description: 'for Environmental Remediation',
      iconClass: 'fa-seedling',
    },
    {amount: '$296 million', description: 'for Electric Vehicles', iconClass: 'fa-plug'},
    {
      amount: '$268 million',
      description: 'for Airports, Ports & Rail',
      iconClass: 'fa-plane-departure',
    },
  ]

  return (
    <div
      className='row text-light justify-content-around pt-4 pb-0 pb-lg-3'
      style={{marginBottom: '-2%'}}
    >
      {fundingData.map((item, index) => (
        <div
          key={index}
          className='col-lg-2 col-sm-12 p-0'
          style={{
            marginLeft: '10px',
            marginRight: '10px',
            padding: '1!important',
            marginBottom: '2%',
          }}
        >
          <div
            className='card feature-cards text-center'
            style={cardStyle}
            onMouseEnter={(e) => {
              // Explicitly set boxShadow as a string
              e.currentTarget.style.boxShadow = cardHoverStyle.boxShadow as string
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = 'none'
            }}
          >
            <div className='card-body' id='card-body-grids'>
              <i className={`bluecardicon fas ${item.iconClass}`} style={iconStyle}></i>
              <h5>{item.amount}</h5>
              <p>{item.description}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default FundingCardsGrid
